export let resolveFirstAuth: (value: boolean) => void;
export let rejectFirstAuth: (reason?: any) => void;

export const firstAuthPromise = new Promise<boolean>((resolve, reject) => {
    resolveFirstAuth = resolve;
    rejectFirstAuth = reject;
});
